import { reportErrorToSentry } from './initializeSentry';

const loadCdnData = async <T>(path: string): Promise<T | undefined> => {
  try {
    const data: T = await (await fetch(`https://checkout-cdn.aboutyou.cloud/data/${path}`)).json();
    return data;
  } catch (err) {
    console.error(err);
    reportErrorToSentry(err);

    return undefined;
  }
};

export default loadCdnData;
